<template>
  <div class="jgsd-report-container">
    <div class="condition">
      <div class="condition_time">
        <label>日期：</label><DatePicker
          ref="datepicker"
          separator="~"
          default-time="last_7d"
          icon-class="icon-jgsd-dataTime"
          :is-contains-cur-time="true"
          :yesterday-is-contains-cur-time="false"
          @timeChange="timeChange"
        />
      </div>
      <div class="condition_line">
        <div
          class="condition_item"
          v-for="(item, index) in indicator"
          :key="index"
        >
          <i :class="['icon', `icon-jgsd-report-${item.icon}`]" />
          <span>{{ item.count }}</span>
          <span>{{ item.label }}</span>
        </div>
      </div>
    </div>
    <el-tabs
      tab-position="left"
      v-model="activeTab"
    >
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :label="item.label"
        :name="item.code"
      >
        <template slot="label">
          <i :class="['icon', iconClass(item.code)]" />{{ item.label }}
        </template>
        <keep-alive>
          <component
            v-if="item.code === activeTab"
            :is="item.code"
            :ref="item.code"
            :indicator-data="indicatorData"
            :get-time-params="getTimeParams"
          />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  getTimeParamCy,
  formatNumWidthComma,
  getPercentValue
} from '@common/util.js'
import DatePicker from '@components/common/DatePicker'
import check from './components/check'
import review from './components/review'
import APIS from '@apis/jgsd/report.js'
export default {
  name: 'Report',
  props: {},
  components: {
    check,
    review,
    DatePicker
  },
  data() {
    return {
      beginTime: getTimeParamCy('last_7d').startTime,
      endTime: getTimeParamCy('7d').endTime,
      indicator: [
        {
          icon: 'sum',
          label: '数据总量',
          count: 0
        },
        {
          icon: 'system1',
          label: '互联网数据量',
          count: 0
        },
        {
          icon: 'system0',
          label: '上传数据量',
          count: 0
        },
        {
          icon: 'toReview',
          label: '已审读量',
          count: 0
        },
        {
          icon: 'pending',
          label: '待审读量',
          count: 0
        },
        {
          icon: 'reviewCount',
          label: '审校量',
          count: 0
        },
        {
          icon: 'reviewProportion',
          label: '审校比例',
          count: 0
        }
      ],
      indicatorData: {},
      activeTab: 'review',
      tabs: [
        {
          label: '审读统计',
          code: 'review'
        },
        {
          label: '审校统计',
          code: 'check'
        }
      ]
    }
  },
  computed: {
    iconClass() {
      return function(code) {
        let normal = `icon-jgsd-report-tab-${code}`
        return this.activeTab === code ? `${normal}-active` : normal
      }
    },
    getTimeParams() {
      return {
        beginTime: this.beginTime,
        endTime: this.endTime
      }
    }
  },
  created() {
    this.$store.commit('UPDATE_BreadMenuData', [])
    this.getStatisticsBase()
  },
  mounted() {},
  methods: {
    async getStatisticsBase() {
      let { status, data } = await APIS.postStatisticsBase({
        data: this.getTimeParams
      })
      if (status === 0 && data && JSON.stringify(data) !== '{}') {
        this.indicator = this.indicator.map(item => {
          return {
            ...item,
            count:
              item.icon === 'reviewProportion'
                ? data[item.icon]
                : formatNumWidthComma(data[item.icon])
          }
        })
        // 审读记录统计传递
        this.indicatorData = {
          passed: data.passed,
          notPassed: data.didNotPassed,
          total: data.toReview,
          notPassedPercent: getPercentValue(
            [data.didNotPassed, data.passed],
            0
          ),
          passedPercent: getPercentValue([data.didNotPassed, data.passed], 1),
          pending: data.pending,
          sum: data.sum,
          pendingPercent: getPercentValue([data.pending, data.toReview], 0)
        }
      }
    },
    timeChange(value) {
      this.beginTime = value[0]
      this.endTime = value[1]
      this.getStatisticsBase()
    }
  }
}
</script>

<style lang="scss" scoped>
.jgsd-report-container {
  padding-bottom: 20px;
  .condition {
    @extend .comBackground;
    padding: 15px 30px;
    margin-bottom: 13px;
    &_time {
      display: flex;
      align-items: center;
      label {
        font-size: 14px;
        color: #333;
      }
      /deep/ .cy-date-time-picker {
        border: 1px solid #e7e7e7;
        border-radius: 5px;
        overflow: hidden;
        .el-date-editor {
          margin-right: 25px;
        }
        & > .icon {
          top: 8px;
          right: 9px;
        }
      }
    }
    &_line {
      display: flex;
      padding: 10px 0 2px;
    }
    &_item {
      flex-basis: calc(100% / 7);
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 12px;
      span {
        line-height: 18px;
        font-weight: 600;
        &:nth-child(3) {
          color: #777;
          font-weight: 500;
        }
      }
    }
  }
  /deep/ .el-tabs {
    display: flex;
    &__active-bar {
      display: none;
    }
    &__nav-wrap {
      &::after {
        display: none;
      }
    }
    &__item {
      display: flex;
      color: rgba(96, 96, 96, 0.8);
      text-align: center;
      height: 38px;
      align-items: center;
      i {
        vertical-align: middle;
        margin-right: 10px;
      }
      &.is-active {
        color: #4497ec;
        background: rgba(134, 157, 249, 0.1);
      }
    }
    &__header {
      width: 140px;
      flex-shrink: 0;
      padding: 8px 0;
      margin-right: 12px;
      @extend .comBackground;
      height: initial;
    }
    &__content {
      flex: 1;
      @extend .comBackground;
      padding-bottom: 10px;
    }
  }
  /deep/ .jgsd-report-review {
    padding: 0 30px;
    .item {
      margin-bottom: 7px;
      .hd {
        display: flex;
        position: relative;
        align-items: center;
        padding: 19px 0 15px;
        font-size: 14px;
        color: #333;
        &::before {
          position: absolute;
          left: -30px;
          width: 4px;
          height: 15px;
          background: #ea5521;
          border-radius: 2px;
          content: "";
        }
      }
      .bd {
        display: flex;
        &_item {
          width: 323px;
          margin-right: 20px;
          &:last-child {
            margin: 0;
          }
        }
        .echartsPie {
          height: 300px;
          border: 1px solid #e7e7e7;
          border-radius: 5px;
        }
      }
    }
    .el-table {
      tr {
        &:hover {
          background: #eff7ff;
        }
      }
      &.depart-table {
        .cell {
          .system1,
          .system0 {
            cursor: pointer;
            &.disabled {
              cursor: auto;
            }
          }
        }
      }
    }
  }
}
</style>
